export const subtractTimezoneOffset = (unadjustedDate: Date): Date => {
	const date = new Date(unadjustedDate);
	date.setHours(date.getHours() - date.getTimezoneOffset() / 60);

	return date;
};

export const addTimezoneOffset = (unadjustedDate: Date): Date => {
	const date = new Date(unadjustedDate);
	date.setHours(date.getHours() + date.getTimezoneOffset() / 60);

	return date;
};
